/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".p-toast-detail[_ngcontent-%COMP%]{width:100%;overflow-wrap:break-word;word-break:break-all}  p-toast{z-index:99999}  p-toast .p-toast{opacity:1}@media (max-width:767px){  p-toast .customToast{left:0;padding:0 20px}}@media (max-width:500px){  p-toast .customToast{width:100%}}"];
export { styles as styles };
